import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PartnerComponent } from "./partner/partner.component";
import { PartnerSaveComponent } from "./partner-save/partner-save.component";
import { PartnerDetailsComponent } from "./partner-details/partner-details.component";

const routes: Routes = [
  {
    path: "",
    component: PartnerComponent
  },
  {
    path: "save",
    component: PartnerSaveComponent
  },
  {
    path: ":id",
    component: PartnerDetailsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartnerPlatformRoutingModule {}
